import {GetAPIDomain} from '../Helper'

// Kept separate from ProjectsClient.ts for the same reason ProjectGuestPortalClient.ts is: this
// is called from an anonymous page (ProjectRequestApprovalPage) reached straight off an email
// link, with no session — it has no business pulling in admin-facing, auth'd API calls.
export class ProjectRequestApprovalClient {
  // The endpoint answers 200 with an `outcome` field for every expected result (recorded /
  // alreadyDecided / expired / notFound). Anything else — a 4xx/5xx, or a body without an
  // outcome — is a genuine failure, so it throws and the page shows "something went wrong"
  // rather than trying to read an error body as if it were an outcome.
  static async Respond(token: string, decision: 'approve' | 'reject') {
    const response = await fetch((await GetAPIDomain()) + '/connect/project-requests/' + token, {
      method: 'POST',
      headers: new Headers({
        'content-type': 'application/json',
        // Without this, TenantMiddleware rejects the request with NO_TENANT_FOUND before it
        // ever reaches the controller: this call has no session and no x-account-id to resolve
        // a tenant from, and the path isn't on the middleware's allowlist. The header only
        // tells it to skip that check — the lookup itself is still purely by token. Same
        // header ProjectGuestPortalClient sends for its anonymous calls.
        'x-account-discovery': 'x-account-discovery',
      }),
      body: JSON.stringify({decision}),
    })

    if (!response.ok) throw new Error(`Approval request failed (${response.status})`)

    const data = await response.json()
    if (!data?.outcome) throw new Error('Approval response had no outcome')

    return data
  }
}
